import React from "react";
import PricingSectionPending from "./pricing/PricingSectionPending";
import PricingSectionRejected from "./pricing/PricingSectionRejected";
import PricingSectionQuoteReady from "./pricing/PricingSectionQuoteReady";
import PricingSectionAwaitingApproval from "./pricing/PricingSectionAwaitingApproval";
import PricingSectionToBeReimbursed from "./pricing/PricingSectionToBeReimbursed";
import PricingSectionReimbursed from "./pricing/PricingSectionReimbursed";
import PricingSectionWaitingOnAirline from "./pricing/PricingSectionWaitingOnAirline";
import { getRefundAdminStage } from "../../../../data/flight/order/getRefundAdminGuidance";

function RefundConfimationPricingSection({ data }) {
  const stage = getRefundAdminStage(data);

  switch (stage) {
    case "declined":
    case "supplier_failed":
    case "validation_failed":
      return <PricingSectionRejected data={data} />;
    case "awaiting_agent":
    case "quote_expired":
      return <PricingSectionQuoteReady data={data} />;
    case "needs_airline_submit":
    case "send_failed":
      return <PricingSectionAwaitingApproval data={data} />;
    case "awaiting_supplier":
      return <PricingSectionWaitingOnAirline data={data} />;
    case "needs_reimburse":
    case "settlement_failed":
      return <PricingSectionToBeReimbursed data={data} />;
    case "completed":
      return <PricingSectionReimbursed data={data} />;
    case "needs_review":
    case "needs_manual_review":
    case "needs_quote":
    case "auto_processing":
    default:
      return <PricingSectionPending data={data} />;
  }
}

export default RefundConfimationPricingSection;
